import { useDispatch, useSelector } from 'react-redux';
import { setUsersUni } from '../../../store/auth/actions';
import deepEqual from 'fast-deep-equal/es6/react';
import { ApplicationState } from '../../../store/index';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ViewDropdown } from 'shared-components';
import { IOption } from 'types';
import { useTranslation } from "react-i18next";

/**
 * Generalised institute dropdown selector that works with both the admisssions and cas workflow dashbaords.
 *
 * Accesses the global state to change the auth university and access the university options from config state.
 */
export const InstitutionDropdown = () => {
    const { t } = useTranslation('common');
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { options, defaultOption } = useSelector(
    ({
      config,
      auth,
    }: ApplicationState): {
      options: IOption[];
      defaultOption: IOption;
    } => {
      return {
        options: config.universityIds.sort((a: IOption, b: IOption) => (a.label > b.label ? 1 : -1)),
        defaultOption: config.universityIds.find(uni => uni.value === auth.uni) || config.universityIds[0],
      };
    },
    deepEqual,
  );
  const [selectedOption, setSelectedOption] = useState<IOption>(defaultOption);

  const onSelect = (option: IOption) => {
    const uniId = option?.value;
    if (uniId) {
      const params = new URLSearchParams('');
      params.set('page', '1');
      navigate({ search: params.toString() });
      dispatch(setUsersUni(uniId));
      setSelectedOption(option);
      localStorage.setItem('dashboard-uni-filter-value', uniId);
    }

    return option;
  };

  if (!defaultOption) {
    return null;
  }

  return (
    <ViewDropdown
      label={t('common:institution')}
      options={options}
      defaultOption={selectedOption || defaultOption}
      onSelect={onSelect}
    />
  );
};
